import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'superUser/create',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/SuperUserCreateContainer',
      './modules/SuperUserCreate'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const SuperUserCreate = require('./containers/SuperUserCreateContainer').default
      const actions = require('./modules/SuperUserCreate')
      const reducer = require('./modules/SuperUserCreate').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'superUserCreate', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchGroupTeams()) // API call for fetching groups teams

      /*  Return getComponent   */
      cb(null, SuperUserCreate)

    /* Webpack named bundle   */
    }, 'SuperUserCreate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/SuperUserCreate/index.js